export const replenishmentCreateData = [
    {
        name: "Replenishment Temp 1",
        fromInventoryStatus: "Finished Goods",
        toInventoryStatus: "Finished Goods",
        maxLinesOrTransfer: 5,
        autoRun: true,
    
    },
    {
        name: "Replenishment Temp 2",
        fromInventoryStatus: "Finished Goods",
        toInventoryStatus: "Finished Goods",
        maxLinesOrTransfer: 15,
        autoRun: false,
    }
]

export const InventoryStatusOptions = [
    { value: "Reserved", label: "Reserved" },
    { value: "QC Hold", label: "QC Hold" },
    { value: "Damaged", label: "Damaged" },
    { value: "Finished Goods", label: "Finished Goods" }
]

export const DefaultOptions = { value: "Reserved", label: "Reserved" }